import { useAppSettingsStore } from '../stores/AppSettingsStore'

// Kill-switch: hide QR-login pages and entry points on web until the mobile
// release ships the scanner. Reads the build-time env var VITE_DISABLE_QR_LOGIN
// (injected by Vite via --mode web/web.staging) and gates it on web only.
export function isQrLoginDisabledOnWeb(): boolean {
  const appStore = useAppSettingsStore()
  return appStore.plateform === 'web'
    && import.meta.env.VITE_DISABLE_QR_LOGIN === 'true'
}
